export const Module = 'Credentials';
